import { DetailCard } from "@hatch-digital-nl/abs-storybook/legacy";
import { ComponentProps } from "react";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { getValidityPeriodMetaItem } from "../../../common/utils/getValidityPeriodMetaItem";

type DetailCardMetadataItem = NonNullable<
    ComponentProps<typeof DetailCard>["metadata"]
>[number];

interface Props {
    certificate: CertificateInterface;
}

export const getEmployeeCertificateCardMetadata = (
    props: Props,
): DetailCardMetadataItem[] => {
    const { certificate } = props;

    return [
        getValidityPeriodMetaItem({
            expiresAt: certificate.expires_at,
        }),
    ];
};
